import {
    Configuration,
    DomaineApi,
    DomaineApiApiDomainesGetCollectionRequest,
} from '@europrocurement/l2d-domain/openApi/ApiUtilisateur';

import {
    ApiCollectionResponse,
    FetchCollectionData,
    FetchItemDataType,
    SliceFactory,
} from '@europrocurement/l2d-redux-utils';

import {
    type Mutable,
    type DomainesUtilisateurApiObject,
    type UtilisateursConfigurationParameters,
} from '../types';
import { DOMAINES_SLICE_NAME, UTILISATEUR_REDUCER_NAME } from '../constants';

export type Domaines = DomainesUtilisateurApiObject;

// function declared for the slice Factory
const mapperServices = function (domaines: Domaines) {
    return {
        ...domaines,
    } as Domaines;
};

/**
 * Function that fetch the collection of domaines and store it into the global state Redux
 * @param configuration API configuration parameters
 * @returns the response of API request (get collection/get by id)
 */
export function createDomainesSlice(configuration: UtilisateursConfigurationParameters) {
    const conf = new Configuration(configuration);
    const api = new DomaineApi(conf);

    const fetchDomainesCollection: FetchCollectionData<Domaines> = ({
        pagination: { page, itemsPerPage },
        xIdSociete,
    }) => {
        const input: Mutable<DomaineApiApiDomainesGetCollectionRequest> = {
            xIdSociete,
            page: page + 1,
            itemsPerPage,
        };

        return api
            .apiDomainesGetCollection(input)
            .then((res) => res.data)
            .catch((error) => {
                console.error(error);
            }) as Promise<ApiCollectionResponse<Domaines>>;
    };

    const fetchDomainesItem: FetchItemDataType<Domaines> = ({
        idItem,
        // pagination,
        xIdSociete,
    }) =>
        api
            .apiDomainesDdmIdGet({ ddmId: String(idItem), xIdSociete })
            .then((res) => res.data) as Promise<Domaines>;

    // Use the utilisateur reducer for the constant because it depends to Utilisateur API
    const { slice: domainesSlice, dataSourcesThunks: domainesDataSourcesThunks } =
        SliceFactory.createSlice<DomainesUtilisateurApiObject, Domaines>(
            DOMAINES_SLICE_NAME,
            UTILISATEUR_REDUCER_NAME,
            [],
            fetchDomainesCollection,
            fetchDomainesItem,
            mapperServices,
            {},
        );
    return { domainesSlice, domainesDataSourcesThunks };
}
